import { Injectable } from '@angular/core';
import { Week} from '../../models/week';
import { APIService } from '../api.service';
import { Observable } from 'rxjs';
import { ReturnObject } from '../../models/returnObject';

@Injectable()
export class WeekService {

    constructor(private api: APIService) {
    }

    getReportableWeeks(email: string): Observable<ReturnObject<Week[]>> {
        return this.api.getAPI(`week/reportable/${email.toUpperCase()}`);
    }

    getNonReportableWeeks(email: string): Observable<ReturnObject<Week[]>> {
        return this.api.getAPI(`week/nonreportable/${email.toUpperCase()}`);
    }
}
